export const SET_ERROR = "error/sagas/FETCH_ERROR";
